import React from 'react';

import { SlicePage } from '../../components/SlicePage';
import { SCAN_VIEWS } from '../../consts';

export const ThreeD = () => {
  return <SlicePage scanView={SCAN_VIEWS.threeD} />;
};
